import { NO_SEARCH_RESULTS_TEST_ID } from './constants';

export const NoSearchResult = () => {
  return (
    <div
      data-testid={NO_SEARCH_RESULTS_TEST_ID}
      className="size-full rounded-2xl bg-white p-8 text-center shadow-plain-lg"
    >
      <h2 className="text-xl font-medium">No search result</h2>
      <p className="mt-6">
        We could not find any results matching the applied search criteria.
        <br />
        Please adjust your search criteria and try again.
      </p>
    </div>
  );
};
